import React from 'react';
import './RecommendationCard.css';

const RecommendationCard = ({ title, description, icon, impact, category }) => {
  return (
    <div className="recommendation-card">
      <div className="recommendation-icon">
        {icon}
      </div>
      <div className="recommendation-content">
        <h3>{title}</h3>
        <p>{description}</p>
        {impact && (
          <div className="recommendation-impact">
            <span>Impacto estimado: {impact}</span>
          </div>
        )}
        {category && (
          <div className="recommendation-category">
            <span>{category}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecommendationCard; 